import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { FormTypeName } from "../formType/FormTypeName";
import { Header, Message, Button, Form, Divider, SelectProps } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import SchemaForm from "../SchemaForm";
import { TFunction } from "i18next";
import IObservation from "../../interfaces/IObservation";
import { useSaveObservation } from "../../data/observation/useSaveObservation";
import { useCategoryList } from "../../store/selectors/categorySelectors";
import { isLoaded } from "../../../../sg-core";
import { useFormTypeList } from "../../store/selectors/formSelectors";

const getTextProps = (t: TFunction) => ({
    headerText: t("Muokkaa havaintoa"),
    saveButtonText: t("Tallenna"),
    cancelButtonText: t("Peruuta"),
    categorySlashForm: t("Kategoria/Lomake"),


    submitSuccessText: t("Tallennus onnistui"),
    submitErrorText: t("Tallennuksessa tapahtui virhe!"),
    formLoadErrorText: t("Lomakkeen haku epäonnistui!"),

});


interface IObservationForm {
    observation: IObservation;
    onSuccess: () => void;
    onCancel: () => void;
}

const ObservationEditing: React.FC<IObservationForm> = ({
    observation,
    onSuccess,
    onCancel
}) => {

    const { t } = useTranslation();
    const texts = getTextProps(t);

    const [startSubmit, invokeSubmit] = useState(false);

    const [editedObservation, setEditedObservation] = useState(observation);
    const { save, saveError, saving, savedAt } = useSaveObservation(observation, editedObservation.formType)


    useEffect(() => {
        if (startSubmit) {
            save(editedObservation.formData)
        }
    }, [startSubmit])


    const categories = useCategoryList();
    const formTypes = useFormTypeList();
    const formTypeOptions = useMemo(() => {
        if (isLoaded(formTypes) && isLoaded(categories)) {
            return formTypes.data.map((form) => {
                const category = categories.data.find((category) => form.category === category.id)
                return { text: [category?.name, form.name].join(" / "), value: form.id }
            })
        }
        return [];
    }, [formTypes]);



    const handleFormTypeChange: SelectProps["onChange"] = (_1, { value }) => {
        if (value) {
            setEditedObservation((prev) => ({ ...prev, formType: value as any }))
        }
    };



    const handleSubmit = (values: { [key: string]: any }) => {
        setEditedObservation((prev) => ({ ...prev, formData: values }))
        invokeSubmit(true)
    };


    const completeButton = useRef<HTMLButtonElement>(null);
    const clickSubmit = () => {
        if (completeButton.current) {
            completeButton.current.click();
        }
    };

    useEffect(() => {
        if (savedAt) {
            onSuccess()
        }
    }, [savedAt]);


    if (savedAt) {
        return (
            <Message content={t("Lomake tallennettu")} negative />
        )
    }

    if (!observation.formSchema) {
        return <Message content={t("Lomakkeen määritystiedosto puuttuu")} negative />;
    }



    return (
        <Fragment>
            <Header size="large" as="h1">{texts.headerText}  </Header>
            <div>
                <FormTypeName formTypeId={editedObservation.formType} />
            </div>
            <br />

            {saveError && <Message negative header={texts.submitErrorText} content={saveError} />}

            <Form as="div">
                <Form.Select label={texts.categorySlashForm} options={formTypeOptions} value={editedObservation.formType} onChange={handleFormTypeChange} search />
            </Form>

            <Divider hidden />
            <SchemaForm
                formSchema={observation.formSchema}
                onSubmit={handleSubmit}
                formData={editedObservation.formData}
                canViewNames // Refactoring needed, this property should be evaluated
            >
                <button ref={completeButton} type="submit" style={{ display: "none", opacity: 0 }} />
            </SchemaForm>


            {saveError && <Message negative header={texts.submitErrorText} content={saveError} />}
            <br />
            <Button primary onClick={clickSubmit} loading={saving}>{texts.saveButtonText}</Button>
            <Button content={texts.cancelButtonText} type="button" onClick={onCancel} />

        </Fragment>
    );
};


export default ObservationEditing;
